import { TEXT_LAYOUTS, buildDynamicTextLayouts } from './textLayouts';
import { buildNumericLayouts, computeDotRow } from './numericLayouts';

export { computeDotRow };

/**
 * Assemble the full allLayouts object.
 *
 * This is called inside two separate useMemo layers in useKeyboardState:
 *   1. baseLayouts — depends on everything EXCEPT typed
 *   2. dotRow      — depends only on [isDot, typed]
 *   3. allLayouts  — merges the two
 *
 * @param {object} opts
 * @param {boolean} opts.isDone
 * @param {boolean} opts.isClr
 * @param {boolean} opts.zipcodeFlag
 * @param {boolean} opts.isDot
 * @param {boolean} opts.isOrderSeat
 * @param {boolean} opts.isOfflinePay
 * @param {boolean} opts.callApi
 * @param {boolean} opts.orderSearch
 * @param {string}  opts.screenType
 * @param {Array}   opts.dotRow  — pre-computed dot row (from computeDotRow)
 */
export function buildLayouts({
  isDone,
  isClr,
  zipcodeFlag,
  isDot,
  isOrderSeat,
  isOfflinePay,
  callApi,
  orderSearch,
  screenType,
  dotRow,
}) {
  const { emailText, textDefaultCaps } = buildDynamicTextLayouts({
    isDone,
    isOrderSeat,
    isOfflinePay,
    callApi,
    orderSearch,
  });

  const number = buildNumericLayouts({
    isClr,
    zipcodeFlag,
    isOfflinePay,
    callApi,
    screenType,
    dotRow,
  });

  return {
    ...TEXT_LAYOUTS,
    emailText,
    textDefaultCaps,
    number,
  };
}

/**
 * Map a keyboard `type` string to the initial layout row array.
 */
export function getInitialLayout(type, allLayouts) {
  switch (type) {
    case 'text':                    return allLayouts.text.default;
    case 'textWithoutNumeric':      return allLayouts.textWithoutNumeric.default;
    case 'textWithNumericEmail':    return allLayouts.textWithNumericEmail.default;
    case 'textWithoutNumericShift': return allLayouts.textWithoutNumeric.shift;
    case 'surveyText':              return allLayouts.surveyText.default;
    case 'emailText':               return allLayouts.emailText.default;
    case 'textWithOutDone':         return allLayouts.textWithOutDone.default;
    case 'number':                  return allLayouts.number.numericDefault;
    case 'numericAlpha':            return allLayouts.number.numericAlpha;
    case 'swipe':                   return allLayouts.number.numericSwipe;
    case 'numeric':                 return allLayouts.number.numeric;
    case 'dot':                     return allLayouts.number.numericDefaultWithDot;
    case 'withoutDone':             return allLayouts.number.numericDefaultWithoutDone;
    case 'numericWithDot':          return allLayouts.number.numericWithDotClear;
    case 'numericDot':              return allLayouts.number.numericDot;
    case 'numericWithBin':          return allLayouts.number.numericWithBin;
    case 'numericWithdone':         return allLayouts.number.numericWithdone;
    case 'numericAlphaWithoutDone': return allLayouts.number.numericAlphaWithoutDone;
    case 'numericDefaultWithDone':  return allLayouts.number.numericDefaultWithDone;
    case 'textDefaultCaps':         return allLayouts.textDefaultCaps.default;
    default:                        return allLayouts.text.default;
  }
}
